import React from 'react';

export function ConfirmDialog({ isOpen, title, message, description, confirmText = 'Evet', cancelText = 'İptal', onConfirm, onCancel, isDangerous = false }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(2px)',
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        padding: 28,
        maxWidth: 420,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
        border: 'none',
        animation: 'slideUp 0.3s ease-out',
      }}>
        {title && (
          <h3 style={{
            margin: '0 0 12px 0',
            fontSize: 18,
            fontWeight: 600,
            color: '#1f2937',
            textAlign: 'center',
            letterSpacing: '-0.3px',
          }}>
            {title}
          </h3>
        )}
        {message && (
          <p style={{
            margin: '0 0 8px 0',
            fontSize: 15,
            color: '#4b5563',
            lineHeight: 1.5,
            textAlign: 'center',
          }}>
            {message}
          </p>
        )}
        {description && (
          <p style={{
            margin: '0 0 28px 0',
            fontSize: 13,
            color: '#6b7280',
            lineHeight: 1.5,
            textAlign: 'center',
          }}>
            {description}
          </p>
        )}
        <div style={{
          display: 'flex',
          gap: 10,
          justifyContent: 'flex-end',
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: '#f3f4f6',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 500,
              color: '#4b5563',
              transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#e5e7eb';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#f3f4f6';
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: isDangerous ? 'var(--danger)' : '#3b82f6',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 500,
              color: '#ffffff',
              transition: 'all 0.15s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = isDangerous ? '#dc2626' : '#2563eb';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = isDangerous ? '0 4px 12px rgba(226, 68, 92, 0.3)' : '0 4px 12px rgba(59, 130, 246, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = isDangerous ? 'var(--danger)' : '#3b82f6';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
